import { useState, useEffect } from 'react';
import styles from '../FilterOptions.module.scss';
import { Label, Switch } from '@components/index';
import { UserID } from '@state';
import { useRecoilValue } from 'recoil';
import { TEXT_WEIGHT } from '@types';

type FilterProps = {
    meta: any;
    header: any;
    filterData: any;
    onChange: (val:any) => void;
}

export const FilterAssignedToMe = (props:FilterProps) => {
	const {
		meta,
		header,
		filterData,
		onChange
	} = props;
	const userID = useRecoilValue(UserID);
	const fullName = meta?.columnFullName;
	const [switchChecked, setSwitchChecked] = useState(false);
	const changeSwitchValue = () => {
		setSwitchChecked(!switchChecked);
		onChange(!switchChecked ? {
			value: userID,
			columnField: meta?.databaseLocation,
			operatorValue: 'is'
		} : null);
	}
	useEffect(() => {
		setSwitchChecked(filterData?.value || false);
	}, [filterData]);
	return (
		<div className={styles.filterLabel}>
			<Label text={fullName !== undefined ? fullName : header} weight={TEXT_WEIGHT.SEMI_BOLD} />
			<Switch name={'Filter-Option-Assigned-To-Me'} value={fullName !== undefined ? fullName : header} checked={switchChecked} onChange={() => changeSwitchValue()} />
		</div>
	);
}
